{
  "$schema": "passport-badges-v1",
  "version": "1.0",
  "updatedAt": "2026-03-02",
  "content": {
    "citizenBadges": [
      {
        "code": "legal_expert",
        "name": "Legal Expert",
        "description": "Mastered the legal track and civic rights",
        "rarity": "rare",
        "milesReward": 1000,
        "displayOrder": 1,
        "icon": "scale",
        "color": "#60A5FA",
        "isActive": true,
        "requirements": {
          "qultureup_legal_advanced": { "min": 1 },
          "teleportal_legal_track": { "min": 1, "type": "all_completed" }
        }
      },
      {
        "code": "culture_citizen",
        "name": "Culture Citizen",
        "description": "Completed all cultural worlds at Advanced level",
        "rarity": "epic",
        "milesReward": 1500,
        "displayOrder": 2,
        "icon": "globe",
        "color": "#A78BFA",
        "isActive": true,
        "requirements": {
          "qultureup_worlds_advanced": { "min": 5 },
          "months_on_journey": { "min": 6 }
        }
      },
      {
        "code": "workplace_master",
        "name": "Workplace Master",
        "description": "Workplace adaptation and language mastery complete",
        "rarity": "epic",
        "milesReward": 1500,
        "displayOrder": 3,
        "icon": "briefcase",
        "color": "#A78BFA",
        "isActive": true,
        "requirements": {
          "qultureup_workplace_advanced": { "min": 1 },
          "qultureup_language_advanced": { "min": 1 },
          "months_on_journey": { "min": 6 }
        }
      },
      {
        "code": "fully_adapted",
        "name": "Fully Adapted Citizen",
        "description": "Complete integration — all journeys finished",
        "rarity": "legendary",
        "milesReward": 2500,
        "displayOrder": 4,
        "icon": "trophy",
        "color": "#F59E0B",
        "isActive": true,
        "requirements": {
          "citizen_badges_earned": { "min": 3 },
          "care_12mo_checkpoint": { "min": 1 },
          "stamps_earned": { "min": 10 },
          "months_on_journey": { "min": 12 }
        }
      },
      {
        "code": "cultural_ambassador",
        "name": "Cultural Ambassador",
        "description": "Outstanding cultural adaptation — ambassador status",
        "rarity": "legendary",
        "milesReward": 2000,
        "displayOrder": 5,
        "icon": "medal",
        "color": "#F59E0B",
        "isActive": true,
        "requirements": {
          "fully_adapted_badge": { "min": 1 },
          "care_sustained_stability": { "min": 70 },
          "total_miles": { "min": 10000 }
        }
      }
    ]
  }
}
